import { DateTime } from 'luxon';
import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import Imagem from 'Component/Imagem';
import VinculoEmpregaticio from 'Interface/VinculosEmpregaticios';

interface Props {
  dados: VinculoEmpregaticio;
}

const ExperienciaLista = ({ dados }: Props): React.ReactElement => {
  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3">
      <Link to={`/usuarios/editar/${dados.usuario_id}`} target="_blank">
        <Imagem
          src={dados.usuario?.imagem}
          alt={dados.usuario?.nome}
          className="rounded-circle object-fit-cover"
          width="80"
          height="80"
        />
      </Link>
      <div className="ms-4 fs-4">
        <Link
          to={`/usuarios/editar/${dados.usuario_id}`}
          className="text-decoration-none"
        >
          {dados.usuario?.nome}
        </Link>
        <small className="d-block fs-6 text-muted">
          {dados.empresa?.nome_fantasia}
        </small>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end">
        <div className="fs-5 text-end">
          {dados.admissao.data().toLocaleString()}
          <small className="d-block fs-6 text-muted">Admissão em</small>
        </div>
        {dados.periodo_de_experiencia1 >= 0 && (
          <div className="ms-4 fs-5 text-end">
            {dados.periodo_de_experiencia1} dia(s)
            <small className="d-block" style={{ fontSize: 13 }}>
              (
              {DateTime.now()
                .plus({ days: dados.periodo_de_experiencia1 })
                .toLocaleString()}
              )
            </small>
            <small className="d-block fs-6 text-muted">Prazo 1</small>
          </div>
        )}
        <div className="ms-4 fs-5 text-end">
          {dados.periodo_de_experiencia2} dia(s)
          <small className="d-block" style={{ fontSize: 13 }}>
            (
            {DateTime.now()
              .plus({ days: dados.periodo_de_experiencia2 })
              .toLocaleString()}
            )
          </small>
          <small className="d-block fs-6 text-muted">Prazo 2</small>
        </div>
      </BrowserView>
    </div>
  );
};

export default ExperienciaLista;
